import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../../services/ValidationService';
import { Constants } from '../../../../constants';
import { SessionService } from '../../../../session-service.service';
import { GenderEnum } from '../../../../model/enums/GenderEnum';
import { Subscription } from 'rxjs';
import { CalculationResponseResultPremiumDto } from '../../../../model/business/calculation/CalculationResponseResultPremiumDto';
import { SessionGgService } from '../../../../services/session-gg.service';
import { InsuredAttributesDtoExtended } from '../../../../model/business/calculation/InsuredAttributesDto';
import { ApplicationApiService } from '../../../../services/applicationApiService';
import { NOTIFICATION_TYPE, NotificationEvent, NotificationService } from '../../../../services/NotificationService';
import { TranslateService } from '@ngx-translate/core';
import { QuotationRequestFailedKnowledgeTestDto } from '../../../../model/business/calculation/QuotationRequestDto';
import { EnumConverterService } from '../../../../services/EnumConverterService';

@Component({
  selector: 'app-knowledge-test-email-offer-form',
  templateUrl: './knowledge-test-email-offer-form.component.html',
  styleUrls: ['./knowledge-test-email-offer-form.component.css']
})
export class KnowledgeTestEmailOfferFormComponent implements OnInit, OnDestroy{
  form: FormGroup;
  phonePattern = Constants.phonePattern;
  phoneMask = Constants.phoneInputMask;
  customerGender: GenderEnum;
  premiumSubscription: Subscription;
  premiums: CalculationResponseResultPremiumDto;
  isSentSuccessfully = false;
  notificationEvent: NotificationEvent;
  notificationSubscription: Subscription;
  genderList = this.enumConverterService.toBaseList('GenderEnum', GenderEnum);

  constructor(
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private sessionService: SessionService,
    private sessionGgService: SessionGgService,
    private apiService: ApplicationApiService,
    private notificationService: NotificationService,
    private translationService: TranslateService,
    private enumConverterService: EnumConverterService,
  ) {
    this.form = this.formBuilder.group({
      customerGender: ['', [Validators.required]],
      customerName: ['', [Validators.required]],
      customerEmail: ['', [Validators.required, this.validationService.createEmailValidator()]],
      customerPhone: ['', [this.validationService.createPhoneValidator()]],
      sendToIntermediary: false
    });
  }

  ngOnInit(): void {
    this.listenToPremiums();
    this.listenToNotifications();
  }

  listenToPremiums(): void {
    this.premiumSubscription = this.sessionService.getCalculationResponse.subscribe((premiums) => {
      this.premiums = premiums;
    });
  }

  listenToNotifications(): void {
    this.notificationSubscription = this.notificationService.register().subscribe((event) => {
      this.notificationEvent = event;
    });
  }

  ngOnDestroy(): void {
    this.premiumSubscription.unsubscribe();
    this.notificationSubscription.unsubscribe();
  }

  submitForm(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.translationService.get('Common.ValidationFailedMessage').subscribe((message) => {
        this.notificationEvent = {
          type: NOTIFICATION_TYPE.WARNING,
          messages: [message],
        };
      });
    } else {
      this.sendEmail();
    }
  }

  getRequestData(): QuotationRequestFailedKnowledgeTestDto {
    const {
      intermediaryEmail,
      intermediaryPhone,
      intermediaryName,
      intermediaryFee,
    } = this.sessionService.getConfigSettingsDto();

    const {
      sendToIntermediary,
      customerPhone,
      customerEmail,
      customerName,
      customerGender,
    } = this.form.value;

    const { variables, dateOfCommencement, productType, policyTerms, insureds } = this.sessionService.getCallculationRequest();
    const { occupation } = this.sessionGgService.getCalculationPageValues();

    variables.intermediaryFee = {
      type: 'string',
      value: intermediaryFee
    };

    (insureds[0] as InsuredAttributesDtoExtended).occupation = occupation;
    (insureds[0] as InsuredAttributesDtoExtended).gender = customerGender;

    const premiumResponse = this.premiums;

    return {
      intermediaryEmail,
      intermediaryPhone,
      intermediaryName,
      sendToIntermediary,
      customerPhone,
      customerEmail,
      customerName,
      customerGender,
      premiumResponse,
      calculationRequestDto: {
        insureds,
        variables,
        dateOfCommencement,
        productType,
        policyTerms,
      }
    };
  }

  sendEmail(): void {
    this.notificationEvent = {
      type: NOTIFICATION_TYPE.HIDDEN,
    };
    const requestData = this.getRequestData();
    this.apiService.sendQuotationRequest(requestData).subscribe(() => {
      this.isSentSuccessfully = true;
    });
  }
}
